// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"226":"8431d90a","234":"ce0b4be2","344":"ac72d80e","542":"b8feb952","741":"cf47a5b4","786":"ae966103","891":"29b0af96"}[chunkId] + ".js";
};